/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import { Base64 } from 'js-base64'
import Switch from 'react-switch'
import Modal from 'react-modal'
import {
  addDays,
  addMonths,
  isWeekend,
  lightFormat,
  startOfMonth,
} from 'date-fns'

import { FiArrowLeft, FiAlertCircle, FiArrowRight, FiX } from 'react-icons/fi'

import usePersistedState from '../../hooks/usePersistedState'
import { ValorMascarar } from '../../utils/masks'
import calculaIdade from '../../utils/calculaIdade'
import api from '../../services/api'

import InputHidden from '../../components/InputHidden'
import InfoBox from '../../components/InfoBox'
import Button from '../../components/Button'
import Header from '../../components/Header'

import {
  Container,
  Content,
  RadioButton,
  BtnContato,
  InfoContent,
} from './styles'
import {
  UserData,
  UserDetails,
  ConfigData,
  ErroProps,
  Participant,
} from '../../utils/interfaces'

const Resume: React.FC = () => {
  const [userData] = usePersistedState<UserData>('userData', {} as UserData)
  const [userDetails] = usePersistedState<UserDetails>(
    'userDetails',
    {} as UserDetails,
  )
  const [participantsList] = usePersistedState<Participant[]>(
    'participantsGroup',
    [],
  )
  const [configData, setConfigData] = usePersistedState<ConfigData>(
    'configData',
    {} as ConfigData,
  )
  const [, setErroProps] = usePersistedState<ErroProps>(
    'erroProps',
    {} as ErroProps,
  )

  const [authTerms, setAuthTerms] = usePersistedState('authTerms', false)
  const [tipoContato, setTipoContato] = useState('S')
  const history = useHistory()
  const formRef = useRef<FormHandles>(null)
  const [tel, setTel] = useState(userData.phone)
  const [mail, setMail] = useState(userData.email)
  const [clicado, setClicado] = useState(false)

  const [firstParcel, setFirstParcel] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [titleModal, setTitleModal] = useState('')
  const [textModal, setTextModal] = useState('')

  const titleTerms = 'Termo de Adesão'
  const textTerms = `Declaro, para fins de direito, sob pena de invalidação do presente ato, que as informações prestadas e os documentos citados são verdadeiros e autênticos, assumo o compromisso de apresentar, quando solicitado, cópia dos comprovantes originais, ciente da responsabilidade pelas declarações prestadas e que minha inscrição perante o presente plano estará efetivada quando da realização de aporte financeiro ou pagamento da primeira contribuição básica de participante, prevista no artigo 14 do regulamento do Plano.`

  const handleSubmit = useCallback(async () => {
    setClicado(true)
    const parametros = Base64.encode(
      `{"versao":"${configData.tipo}",
        "plano": "${configData.plano}",
        "email":"${userData.email === undefined ? '' : userData.email}",
        "telefone":"${
          userData.phone === undefined
            ? ''
            : `55${userData.phone
                .replace('(', '')
                .replace(') ', '')
                .replace('-', '')}`
        }",
        "cpf": "${userData.cpf
          .replace('.', '')
          .replace('.', '')
          .replace('-', '')}",
        "admissão":"",
        "cliente":"${configData.codCliente}",
        "sistema":"ADZ",
        "envio":"${tipoContato}"}`,
    )

    const parametrosFinal = Base64.encode(parametros)

    await api
      .get(`wsAutenticacao.rule?sys=ADZ&Entrada=${parametrosFinal}`)
      .then(res => {
        setConfigData({
          ...configData,
          token: res.data.token,
          tipoContato,
        })
        history.push('/confirm-sms')
      })
      .catch(res => {
        if (res.message === 'Network Error') {
          setErroProps({
            title: res.message,
            description: 'Falha na conexão com o servidor',
          })
          history.push('/erro')
        } else if (res.message === 'Request failed with status code 500') {
          setErroProps({
            title: 'Erro interno no servidor',
            description: res.message,
          })
          history.push('/erro')
        } else {
          alert('Ops, algo deu errado. Tente novamente mais tarde.')
          setClicado(false)
        }

        setConfigData({
          ...configData,
          tipoContato,
        })
      })
  }, [history, setErroProps, tipoContato, userData, configData, setConfigData])

  const handleConfirmar = useCallback(event => {
    event.preventDefault()
    formRef.current?.submitForm()
  }, [])

  const handleChangeValues = useCallback(() => {
    history.push('/participants-list')
  }, [history])

  function handleOpenModal() {
    setIsModalOpen(true)
  }

  function handleCloseModal() {
    setIsModalOpen(false)
  }

  const toggleAuthTerms = useCallback(() => {
    setAuthTerms(!authTerms)
  }, [authTerms, setAuthTerms])

  useEffect(() => {
    let date = startOfMonth(addMonths(new Date(), 1))
    let countDays = 1
    while (countDays < 10) {
      if (!isWeekend(date)) {
        date = addDays(date, 1)
        countDays += 1
      } else {
        date = addDays(date, 1)
      }
    }
    setFirstParcel(lightFormat(date, 'dd/MM/yyyy'))
  }, [])

  return (
    <>
      <Header>
        <FiArrowLeft
          type="button"
          cursor="pointer"
          onClick={handleChangeValues}
        />
      </Header>

      <Container>
        <Form ref={formRef} onSubmit={handleSubmit} initialData={userData}>
          <Content>
            <h3>
              <strong>Parabéns!</strong> Esse é o caminho certo para realizar
              seus sonhos e investir no seu futuro
            </h3>
            <InfoBox>
              <h3>Resumo da simulação</h3>
              <div className="resume">
                <div>
                  <small id="month-value">Valor mensal investido</small>
                  <span>
                    R${' '}
                    {ValorMascarar(
                      userDetails.contribuicaoBasica.toFixed(2).toString(),
                    )}
                  </span>
                </div>
                <div className="date">
                  <small>Primeira parcela</small>
                  <p>{firstParcel}</p>
                </div>
              </div>
            </InfoBox>

            <RadioButton>
              <h3>Receber código de confirmação da adesão por:</h3>
              <div>
                <BtnContato
                  type="button"
                  isActive={tipoContato === 'S'}
                  onClick={() => setTipoContato('S')}
                >
                  SMS
                </BtnContato>
                <BtnContato
                  type="button"
                  isActive={tipoContato === 'E'}
                  onClick={() => setTipoContato('E')}
                >
                  EMAIL
                </BtnContato>
              </div>
              {tipoContato === 'S' ? (
                <input
                  name="phone"
                  value={`+55 | ${tel}`}
                  onChange={e => setTel(e.target.value)}
                />
              ) : (
                <input
                  name="email"
                  id="email"
                  type="email"
                  maxLength={150}
                  value={mail}
                  onChange={e => setMail(e.target.value)}
                />
              )}
              <InputHidden
                name="tipContato"
                value={tipoContato}
                type="hidden"
              />
            </RadioButton>

            <RadioButton>
              <button
                type="button"
                onClick={() => {
                  handleOpenModal()
                  setTitleModal(titleTerms)
                  setTextModal(textTerms)
                }}
              >
                Visualizar termos
                <FiAlertCircle />
              </button>
              <div id="terms">
                <Switch
                  onChange={toggleAuthTerms}
                  checked={authTerms}
                  checkedIcon={false}
                  uncheckedIcon={false}
                  height={22}
                  width={44}
                  handleDiameter={18}
                  offColor="#DEE3E1"
                  offHandleColor="#fff"
                  onHandleColor="#fff"
                  onColor="#4CA585"
                  className="switch"
                />
                <small>
                  Declaro que li e aceito as condições gerais e autorizo o
                  compartilhamento dos meus dados e valores das movimentações
                  com a seguradora. Solicito que meus dados sejam apenas usados
                  para as finalidades informadas aqui, e sejam descartados
                  quando o contrato for extinto.
                </small>
              </div>
            </RadioButton>

            <InfoContent>
              <h3>Titular</h3>
              <div>
                <p>{userData.name}</p>
                <small>{userData.phone}</small>
                <br />
                <small>{calculaIdade(userData.birthdate)} anos</small>
              </div>
            </InfoContent>

            {participantsList.length > 0 ? (
              <InfoContent>
                <h3>Beneficiários:</h3>
                {participantsList.map(p => (
                  <div key={Math.random()} className="dependents">
                    <p>{p.data.name}</p>
                    <small>
                      {calculaIdade(p.data.birthdate)}{' '}
                      {calculaIdade(p.data.birthdate) > 1 ? 'anos' : 'ano'}
                    </small>
                    <br />
                    <small>{p.details.dcrGrauParentesco}</small>
                  </div>
                ))}
              </InfoContent>
            ) : (
              <> </>
            )}
          </Content>

          <Button
            type="submit"
            color="green"
            onClick={handleConfirmar}
            disabled={!authTerms || clicado}
          >
            Confirmar
            <div>
              <FiArrowRight />
            </div>
          </Button>

          <Modal
            isOpen={isModalOpen}
            onRequestClose={handleCloseModal}
            overlayClassName="react-modal-overlay"
            className="react-modal-content"
          >
            <FiX onClick={handleCloseModal} />
            <h3>{titleModal}</h3>
            <p>{textModal}</p>
          </Modal>
        </Form>
      </Container>
    </>
  )
}

export default Resume
